
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sandbox/institutions",
      function () {
        return require("private-next-pages/docs/sandbox/institutions.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sandbox/institutions"])
      });
    }
  